import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join'
})

export class JoinPipe implements PipeTransform {
  transform(input: any[], key: string): any {
    return input.join(key);
  }
}
